<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-card class="mx-auto" >
      <v-card-text>
        <h2 class="font-weight-light">CENTRAL DE SOLUÇÕES</h2>
        <br>
        <p><v-icon x-large color="blue">question_answer</v-icon></p>
        <p>Abra chamados e tire suas dúvidas com os administradores</p>
        <v-card-actions>
          <v-list-tile class="grow">
            <v-layout align-center justify-end>
              <v-btn round right small color="info" @click="openNewTicket">
                Novo chamado<v-icon>add</v-icon>
              </v-btn>
            </v-layout>
          </v-list-tile>
        </v-card-actions>
      </v-card-text>
    </v-card>
      <tickets-table />
    <new-ticket />
  </v-container>
</template>
<script>

import { EventBus } from '@/services/event-bus';

export default {
  name: 'Tickets',
  components: {
    TicketsTable: () => import('@/components/tickets/TicketsTable.vue'),
    NewTicket: () => import('@/components/tickets/NewTicket.vue'),
  },
  methods: {
    openNewTicket() {
      EventBus.$emit('show-new-ticket-form');
    },
  },
};
</script>
